import { render, staticRenderFns } from "./BeautyForm.vue?vue&type=template&id=38593528&scoped=true"
import script from "./BeautyForm.vue?vue&type=script&lang=js"
export * from "./BeautyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38593528",
  null
  
)

export default component.exports